import './style.scss';
import { ResultBody, ResultHeader } from 'views/mutual/result';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { FormikProps } from 'formik';
import { ApplySymbolInput } from '../hooks';
import { DateFormatType, formatDate, formatPrice } from 'views/utils/converter';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { ContractDetailInfo, DomesticRealEstateSymbolDetailInfo } from 'views/utils/graphql/graphql';
import { useSymbolApplyConfirm } from './hooks';
import PDFViewer from 'views/mutual/pdfViewer';
import { CheckLabel } from 'views/mutual/checkLabel';
export type DomesticRealEstateRequestConfirmProps = {
  symbolDetail: DomesticRealEstateSymbolDetailInfo;
  applicationID: string;
  formik: FormikProps<ApplySymbolInput>;
  backDetailPage: () => void;
  contractInfo: ContractDetailInfo;
};
export const DomesticRealEstateSymbolApplyConfirm = ({
  symbolDetail,
  applicationID,
  formik,
  backDetailPage,
  contractInfo,
}: DomesticRealEstateRequestConfirmProps) => {
  useCustomLocationName('申込内容確認');
  const {
    checkProps,
    isDisabled,
    setIsScrolledSalesContractPdf,
    setIsScrolledTransferConsentRequestPdf,
    SalesContractPdfData,
    TransferConsentRequestPdfData,
  } = useSymbolApplyConfirm(applicationID);

  return (
    <>
      <div className="domesticRealEstate-symbolConfirm_requestConfirm">
        <div className="domesticRealEstate-symbolConfirm_requestConfirm_results">
          <div className="domesticRealEstate-symbolConfirm_requestConfirm_description">
            <Description
              labelColor={labelColor.black}
              labelSize={labelSize.medium}
              label={`ご契約内容をご確認いただくため、書類を一番下までスクロールしてください。スクロールが完了すると、ボタンが押せるようになります。`}
            />
          </div>
          <ResultHeader label="案件名称" />
          <ResultBody label={symbolDetail.ProductName!} />
          <ResultHeader label="申込金額" />
          <ResultBody label={formatPrice(contractInfo.ApplicationAmount) + '円'} />
          <ResultHeader label="振込期日" />
          <ResultBody label={formatDate(new Date(symbolDetail.TransferDate!), DateFormatType.Japanese_yyyyMd)} />
          <ResultHeader label="諸費用　※確定日付取得費用" />
          <ResultBody label={formatPrice(contractInfo.ExpensesTotal) + '円'} />
          <ResultHeader label="購入代金総額" />
          <ResultBody label={formatPrice(contractInfo.TotalTransferFee) + '円'} />
          <div className="domesticRealEstate-symbolConfirm_requestConfirm_results_documents">
            <div><PDFViewer file={SalesContractPdfData} isBottom={() => setIsScrolledTransferConsentRequestPdf(true)} /></div>            
            <div><PDFViewer file={TransferConsentRequestPdfData} isBottom={() => setIsScrolledSalesContractPdf(true)} /></div>            
          </div>
          <div className="domesticRealEstate-symbolConfirm_requestConfirm_checkLabel">
            <CheckLabel
              before="本信託受益権の譲受人である私（当社）は、譲渡人である株式会社FPGと連名で、この譲渡承諾請求書を受託者に提供することによって、本信託受益権の譲渡承諾を請求します。"
              {...checkProps}
            />
          </div>
          <div className="domesticRealEstate-symbolConfirm_requestConfirm_description">
            <Description
              labelColor={labelColor.black}
              labelSize={labelSize.large}
              label={`上記の通り、不動産信託受益権の購入を申込みます。`}
            />
          </div>
        </div>

        <div className="domesticRealEstate-symbolConfirm_requestConfirm_buttons">
          <Button
            label={'契約締結を申込む'}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            disable={isDisabled}
            onClick={formik.handleSubmit}
          />
          <Button
            label="案件詳細画面へ戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={backDetailPage}
          />
        </div>
      </div>
    </>
  );
};
